import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable, switchMap, take } from "rxjs";
import { AuthService } from "@services";
import { RequestHeaderService } from "../service/request-header.service";
import packageJson from "../../../../package.json";

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  constructor(
    private _authService: AuthService,
    private _headerService: RequestHeaderService,
  ) {}

  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return this._authService.getIdToken().pipe(
      take(1),
      switchMap((token) => {
        const headers: Record<string, string> = {};

        if (token) {
          headers["Authorization"] = `Bearer ${token}`;
        }

        const visitorId = this._headerService.getRequestHeaderValue();
        if (visitorId) {
          headers["VisitorId"] = visitorId;
        }

        //send semver version of frontend
        if (packageJson.version) {
          headers["FrontendVersion"] = packageJson.version;
        }

        request = request.clone({
          setHeaders: headers,
          url: request.url.startsWith("http") ? request.url : "",
        });

        return next.handle(request);
      }),
    );
  }
}
